import "./PaneStack.css";

export function PaneStack({
  children,
  gap = "var(--layout-gap, var(--layout-stack-gap))",
  className = "",
  fill = false,
  distribute = "natural"
}) {
  const resolvedClassName = [
    "pane-stack",
    fill ? "pane-stack--fill" : "",
    distribute === "equal" ? "pane-stack--equal" : "",
    className
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div class={resolvedClassName} style={{ "--pane-stack-gap": gap }}>
      {children}
    </div>
  );
}
